import { tierCalculatedDateAtom } from '@activities/tier/TierHistoryActivity/atoms/tierAtoms';
import Badge from '@components/Badge';
import BottomSheetHeader from '@components/BottomSheetHeader';
import Column from '@components/Column';
import Loading from '@components/Loading';
import Radio from '@components/Radio';
import styled from '@emotion/styled';
import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import useCalculationCycles from './hooks/useCalculationCycles';

declare module '@stackflow/config' {
    interface Register {
        TierCalculatedDateBottomSheet: {};
    }
}

const TierCalculatedDateBottomSheet: ActivityComponentType<'TierCalculatedDateBottomSheet'> = () => {
    const { t } = useTranslation('tier');
    const { data, isFetching } = useCalculationCycles();
    const [date, setDate] = useAtom(tierCalculatedDateAtom);
    const { pop } = useFlow();
    return (
        <BottomSheet>
            <BottomSheetHeader>
                {t('tierCalculatedDate.title')}
            </BottomSheetHeader>
            {isFetching && (
                <Loading size='small' />
            )}
            <Container fullWidth >
                {data?.periods.map((period) => (
                    <RadioWrapper key={period.periodStart} >
                        <div>
                            <Radio value={period.periodStart}
                                isSelected={date === period.calculatedDate}
                                onChange={() => {
                                    setDate(period.calculatedDate);
                                    pop();
                                }} >
                                {period.periodStart}
                                &nbsp;~&nbsp;
                                {period.periodEnd}
                            </Radio>
                        </div>
                        {period.status === 'IN_PROGRESS' && (
                            <Badge>{t('tierCalculatedDate.inProgress')}</Badge>
                        )}
                    </RadioWrapper>
                ))}
            </Container>
        </BottomSheet>
    );
};

const Container = styled(Column)`
    padding: 16px 16px calc(16px + var(--safe-area-bottom));
`;

const RadioWrapper = styled.div`
    padding: 8px 0;
    display: flex;
    width: 100%;
    gap: 8px;
`;

export default TierCalculatedDateBottomSheet;
